
import { Link } from "../router";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import type { NavItem } from "./nav";
import { RailTooltip } from "./RailTooltip";
import styles from "./shell.module.css";

type Props = {
  item: NavItem;
  active: boolean;
  withTooltip: boolean;
  onNavigate?: () => void;
};

export function PendingLabel({ className, children }: { className: string; children: ReactNode }) {
  return <span className={className}>{children}</span>;
}

export function NavLink({ item, active, withTooltip, onNavigate }: Props) {
  const { t } = useTranslation();
  const Icon = item.icon;
  const label = t(`nav.${item.id}`);
  const link = (
    <Link
      href={item.href}
      className={styles.navItem}
      aria-current={active ? "page" : undefined}
      onClick={onNavigate}
    >
      <Icon className={styles.navIcon} strokeWidth={1.75} aria-hidden="true" />
      <PendingLabel className={styles.navLabel}>{label}</PendingLabel>
    </Link>
  );

  return (
    <RailTooltip
      enabled={withTooltip}
      content={
        <>
          <span className={styles.tooltipTitle}>{label}</span>
          {t(`nav.${item.id}Desc`)}
        </>
      }
    >
      {link}
    </RailTooltip>
  );
}
